/**
 * Простой конвертер markdown в HTML для статей
 * Обрабатывает: **, *, #, ##, ###, >, ---, списки
 */

export function markdownToHtml(markdown: string): string {
  if (!markdown) return '';

  let html = markdown;

  // Удаляем YAML frontmatter (--- ... ---)
  html = html.replace(/^---[\s\S]*?---\n?/, '');

  // Заголовки
  html = html.replace(/^### (.+)$/gm, '<h3>$1</h3>');
  html = html.replace(/^## (.+)$/gm, '<h2>$1</h2>');
  html = html.replace(/^# (.+)$/gm, '<h1>$1</h1>');

  // Жирный текст
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // Курсив
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');

  // Цитаты
  html = html.replace(/^> (.+)$/gm, '<blockquote>$1</blockquote>');

  // Горизонтальная линия
  html = html.replace(/^---$/gm, '<hr />');

  // Таблицы — конвертируем markdown таблицы в HTML
  html = html.replace(/^(\|.+\|)\n(\|[-| :]+\|)\n((?:\|.+\|\n?)*)/gm, (match, headerRow, separatorRow, bodyRows) => {
    const parseRow = (row: string) => row.split('|').filter(cell => cell.trim()).map(cell => cell.trim());
    
    const headers = parseRow(headerRow);
    const rows = bodyRows.trim().split('\n').map(parseRow);
    
    let tableHtml = '<table style="width:100%;border-collapse:collapse;margin:20px 0;">';
    tableHtml += '<thead><tr style="background:rgba(212,175,55,0.15);">';
    headers.forEach(h => { tableHtml += `<th style="padding:12px;text-align:left;border-bottom:2px solid rgba(212,175,55,0.3);color:#d4af37;font-family:var(--font-sans);font-size:14px;">${h}</th>`; });
    tableHtml += '</tr></thead><tbody>';
    rows.forEach(row => {
      tableHtml += '<tr style="border-bottom:1px solid rgba(255,255,255,0.05);">';
      row.forEach(cell => { tableHtml += `<td style="padding:12px;color:#b0b0b0;font-size:14px;font-family:var(--font-sans);">${cell}</td>`; });
      tableHtml += '</tr>';
    });
    tableHtml += '</tbody></table>';
    
    return tableHtml;
  });

  // TL;DR блоки — полностью удаляем
  html = html.replace(/\*\*TL;DR:\*\*[^\n]*/g, '');
  html = html.replace(/TL;DR:[^\n]*/g, '');
  html = html.replace(/<div class="tldr">[^<]*<\/div>/g, '');

  // Списки
  html = html.replace(/^- (.+)$/gm, '<li>$1</li>');
  html = html.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');

  // Параграфы (двойные переносы)
  html = html.replace(/\n\n/g, '</p><p>');
  html = '<p>' + html + '</p>';

  // Очистка пустых параграфов
  html = html.replace(/<p><\/p>/g, '');
  html = html.replace(/<p>(<h[123]>)/g, '$1');
  html = html.replace(/(<\/h[123]>)<\/p>/g, '$1');
  html = html.replace(/<p>(<ul>)/g, '$1');
  html = html.replace(/(<\/ul>)<\/p>/g, '$1');
  html = html.replace(/<p>(<blockquote>)/g, '$1');
  html = html.replace(/(<\/blockquote>)<\/p>/g, '$1');
  html = html.replace(/<p>(<hr \/>)/g, '$1');
  html = html.replace(/(<hr \/>)<\/p>/g, '$1');

  // Очистка лишних переносов
  html = html.replace(/\n/g, '<br />');

  return html;
}
